function animateOnScroll(selector) {
  gsap.utils.toArray(selector).forEach((el) => {
    gsap.from(el, {
      scrollTrigger: {
        trigger: el,
        start: "top 105%"
      },
      duration: 2,
      y: 100,
      opacity: 0
    });
  });
}

animateOnScroll(".rich-text__inner");
animateOnScroll(".section-header");
animateOnScroll(".product-card");

gsap.utils.toArray(".image-with-text__inner").forEach((el) => {
  gsap.from(el, {
    scrollTrigger: {
      trigger: el,
      start: "top 105%", // adjust when it fires
      toggleActions: "play none none none"
    },
    duration: 2,
    y: 100,
    opacity: 0
  });
});


function navSelected() {
  let currentSelected = null;

  const menuItems = document.querySelectorAll(
    '.menu_container > .sub-menu > li'
  );

  menuItems.forEach(li => {
    const link = li.querySelector(':scope > a');

    if (link) {
      link.addEventListener('mouseenter', () => {
        // remove previous selected + open submenu
        if (currentSelected) {
          currentSelected.classList.remove('selected');

          const prevLi = currentSelected.parentElement;
          const prevSub = prevLi.querySelector(':scope > .sub-menu');
          if (prevSub) prevSub.classList.remove('show');
        }

        // set new selected
        link.classList.add('selected');
        currentSelected = link;

        // check if this li has children
        if (li.classList.contains('menu-item-has-children')) {
          const childMenu = li.querySelector(':scope > .sub-menu');
          if (childMenu) {
            childMenu.classList.add('show');
          }
        }
      });
    }
  });
}

function enableNavHoverBodyClass() {
  const items = document.querySelectorAll('.thb-full-menu > li');
  const body = document.body;

  items.forEach(li => {
    li.addEventListener('mouseenter', () => {
      body.classList.add('nav-hover');
    });

    li.addEventListener('mouseleave', () => {
      body.classList.remove('nav-hover');
    });
  });
}

enableNavHoverBodyClass();

navSelected();


